import { notify } from "../../components/controls/ms-notification/index";
import i18n from "../../i18ns/i18n.js";
import {
  SuccessEnum,
  NotifySendSalaryEnum,
  TypeNotifyEnum,
} from "./NotifyEnum";

export const _success = (mode, customContent = null) => {
  var content = customContent;
  if (!content && mode) {
    switch (mode) {
      case SuccessEnum.Insert:
        content = i18n.tc("i18nNotify.SucessInsert");
        break;
      case SuccessEnum.Update:
        content = i18n.tc("i18nNotify.SucessUpdate");
        break;
      case SuccessEnum.Delete:
        content = i18n.tc("i18nNotify.SucessDelete");
        break;
      case SuccessEnum.Replication:
        content = i18n.tc("i18nNotify.SucessReplication");
        break;
      default:
        break;
    }
  }
  notify({
    typeNotify: TypeNotifyEnum.Default,
    color: "success",
    title: null,
    text: content,
    icon: "mi-circle-check-white",
    fullWidth: true,
  });
};


export const _error = (customContent = null) => {
  var content = i18n.tc("i18nNotify.Error");
  notify({
    typeNotify: 1,
    color: "error",
    title: null,
    text: customContent ? customContent : content,
    icon: "icon-infor-white",
  });
};
export const _warning = (customContent = null) => {
  var content = i18n.tc("i18nNotify.Error");
  notify({
    typeNotify: 1,
    color: "warning",
    title: null,
    text: customContent ? customContent : content,
    icon: "icon-infor-white",
    fullWidth: true,
  });
};

export const _sendSalary = (mode) => {
  var content = "";
  var notifyText = "";
  var color = "success";
  var icon = "";
  switch (mode) {
    case NotifySendSalaryEnum.Success:
      notifyText = i18n.tc("i18nNotify.SuccessNotify");
      content = i18n.tc("i18nNotify.SendSalarySuccess");
      color = "success";
      icon = "mi-circle-check-white";
      break;
    case NotifySendSalaryEnum.Error:
      notifyText = i18n.tc("i18nNotify.ErrorNotify");
      content = i18n.tc("i18nNotify.SendSalaryFailed");
      color = "error";
      icon = "mi-alert-error-red";
      break;
    default:
      break;
  }

  notify({
    typeNotify: TypeNotifyEnum.SendSalary,
    color: color,
    title: null,
    notifyText: notifyText,
    text: content,
    icon: icon,
    fullWidth: true,
  });
};
